import { useTranslation } from "react-i18next";
import { Badge, type BadgeProps } from "@/components/ui/badge";
import type { SubscriptionStatus } from "../api";

const variantByStatus: Record<SubscriptionStatus, BadgeProps["variant"]> = {
  none: "neutral",
  active: "success",
  trialing: "info",
  past_due: "warning",
  cancelled: "neutral",
  expired: "danger",
};

export function SubscriptionStatusBadge({ status }: { status: SubscriptionStatus }) {
  const { t } = useTranslation(undefined, { keyPrefix: "subscription" });
  return (
    <Badge variant={variantByStatus[status]} aria-label={t(`status.${status}`)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
